import { useTheme } from "@mui/material";

/**
 * Colours of the three parts of a retailer's clocks. Sold stands out in the
 * brand colour; the other two are neutral overlays that flip with light and
 * dark mode, so nothing here is a hard-coded hex.
 */
export const useSegmentColors = () => {
  const { palette } = useTheme();
  return {
    sold: palette.primary.main,
    notSold: palette.white[56],
    withoutId: palette.white[16],
  };
};

export const SEGMENT_LABELS = {
  sold: "Sold",
  notSold: "Not sold yet",
  withoutId: "No clock id yet",
} as const;
